/**
 * Enum for states of US
 */
export enum USStates {
  CA = 'CA',
}
